import { all, call, put, select, takeEvery, takeLeading } from "redux-saga/effects";
import { editTagEndPoint } from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";
import { handleApiError } from "../../global/utility/Utils";
import { ImageDownloadMedia } from "../../model/mediaService";
import {
  fetchTagData,
  filterAndStoreData,
  getTagHierarchy,
  getUserSitesData,
  processNestedTags,
} from "../../model/reportService";
import {
  fetchTagDataForCountries,
  handleSiteDelete,
} from "../../pages/Sites/SiteService";
import {
  apiError,
  deleteSiteFailure,
  deleteSiteSuccess,
  fetchCountryIdsSuccess,
  fetchSitesSuccess,
  fetchedTags,
  saveFloorImageMapping,
  setCombinedCountryTagData,
  setCombinedSitesTagData,
  setLoading,
  siteTagListUpdated,
  types,
  updateCampusDetails
} from "../actions";

const activeSession = (state) => state.sessionReducer.activeSession;
const userRole = (state) => state.userRoleReducer.userRole;
const siteTagListSelector = (state) => state.sitesReducer.siteTagList;
const countryIdsSelector = (state) => state.sitesReducer.countryIds;

function* deleteSite(action) {
  try {
    const session = yield select(activeSession);
    yield put(setLoading(true));
    yield call(handleSiteDelete, action.payload, session.activeSession);
    yield put(deleteSiteSuccess());
    // window.location.reload();
    // yield call(fetchCountryIdsRequest);
    // yield put(fetchSitesRequest());
  } catch (error) {
    yield put(deleteSiteFailure(error));
  }
}

function* fetchCountryIds(action) {
  const session = yield select(activeSession);
  if(session?.activeSession?.accountId != undefined){

  const existingSiteTagList = yield select(siteTagListSelector);
  const hasData = existingSiteTagList?.sites?.length > 0;

  // Skip API entirely when data exists and this is not a forced refresh
  if (hasData && !action.force) {
    yield put(setLoading(false));
    if (action?.meta) action.meta.resolve();
    return;
  }

  // Only show loader for initial (non-forced) loads with no data, or when explicitly requested.
  if (!action.force && (!hasData || action.showLoader)) {
    yield put(setLoading(true));
  }

  try {
  const cachedCountryIds = yield select(countryIdsSelector);
  let countryData;
  if (cachedCountryIds && cachedCountryIds.length > 0) {
    countryData = cachedCountryIds;
  } else {
    countryData = yield call(fetchTagDataForCountries, session.activeSession);
    yield put(fetchCountryIdsSuccess(countryData.length > 0 ? countryData[0] : []));
    yield put({ type: types.PUT_FETCH_COUNTRY_REQUEST, payload: countryData });
  }

  if (!countryData || countryData.length === 0) {
    yield put(setLoading(false));
    if (action?.meta) {
      action.meta.resolve();
    }
    return;
  }

  let combinedResponse = [];
  for (let i = 0; i < countryData.length; i++) {
    const country = countryData[i];
    let countryId = { id: country.id };
    try {
      const response = yield call(
        getTagHierarchy,
        { maxdepth: 8 },
        countryId,
        session.activeSession
      );
      combinedResponse = [
        ...combinedResponse,
        ...[{ ...country, nestedtags: [...response] }],
      ];
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  const hasHierarchyData = combinedResponse.some((c) => c.nestedtags?.length > 0);
  const userRoleText = yield select(userRole);
  const userSiteData = yield call(getUserSitesData, session.activeSession);

  if (
    !userSiteData.length &&
    (userRoleText?.toLowerCase() === "admin" ||
      JSON.parse(sessionStorage.getItem("selectedRole")) === "Admin")
  ) {
    if (hasHierarchyData || !hasData) {
      const processedNestedData = processNestedTags(combinedResponse);
      const floors = processedNestedData?.floors;
      floors.forEach(function* ({ id, imageid }) {
        try {
          const url = yield call(ImageDownloadMedia, imageid, session.activeSession);
          yield put(saveFloorImageMapping(id, url));
        } catch (error) {
          console.log("Error while getting tags -> " + error);
        }
      });
      var taglistArray = [];
      Object.keys(processedNestedData).forEach((element) => {
        taglistArray = [...taglistArray, ...processedNestedData[element]];
      });
      yield put({
        type: types.PROCESS_NESTED_SITE_TAG_LIST,
        payload: { ...processedNestedData },
      });
      yield put({ type: types.SETALLTAGLIST, payload: taglistArray });
      yield put(setCombinedCountryTagData(combinedResponse));
      const processedData = processSitesTags(combinedResponse);
      yield put(fetchSitesSuccess(processedData));
    }
  } else {
    if (hasHierarchyData || !hasData) {
      const processedNestedData = processNestedTags(combinedResponse);
      const floors = processedNestedData?.floors;
      floors.forEach(function* ({ id, imageid }) {
        try {
          const url = yield call(
            ImageDownloadMedia,
            imageid,
            session.activeSession
          );
          yield put(saveFloorImageMapping(id, url));
        } catch (error) {
          console.log("Error while getting tags -> " + error);
        }
      });
      const userActualSitesData = (Array.isArray(userSiteData) ? userSiteData : []).filter((item) =>
        processedNestedData?.sites?.some((data) => data?.id === item?.id)
      );
      processedNestedData.sites = userActualSitesData;
      var taglistArray = [];
      Object.keys(processedNestedData).forEach((element) => {
        taglistArray = [...taglistArray, ...processedNestedData[element]];
      });
      yield put({
        type: types.PROCESS_NESTED_SITE_TAG_LIST,
        payload: { ...processedNestedData },
      });
      yield put({ type: types.SETALLTAGLIST, payload: taglistArray });
      yield put(setCombinedCountryTagData(combinedResponse));
      let processedData = processSitesTags(combinedResponse);
      processedData = processedData.filter((item) =>
        userActualSitesData.some(
          (u) =>
            u?.id === item?.siteTagId ||
            (item?.children &&
              item?.children?.some((i) => u?.id === i?.siteTagId))
        )
      );
      yield put(fetchSitesSuccess(processedData));
    }
  }
  yield put(setLoading(false));
  if (action?.meta) {
    action.meta.resolve();
  }
  } catch (error) {
    console.error("Error in fetchCountryIds:", error);
    yield put(setLoading(false));
    if (action?.meta) action.meta.resolve();
  }
}
}

function* fetchAllTags() {
  try {
    yield put(setLoading(true));
    const session = yield select(activeSession);
    const tagData = yield call(fetchTagData, session.activeSession);
    const userSiteData = yield call(getUserSitesData, session.activeSession);
    const siteTagList = filterAndStoreData(tagData, userSiteData);
    yield put(siteTagListUpdated(siteTagList));
    if (tagData.error) {
      yield put(setLoading(false));
      yield put(apiError(true));
    } else {
      yield put(fetchedTags(tagData));
      yield put({ type: types.FETCH_ALL_SITES });
    }
  } catch (error) {
    console.log("Error while getting tags -> " + error);
  }
}

function* fetchAllSites() {
  const sitesTagList = JSON.parse(sessionStorage.getItem("SitesTagList"));
  if (sitesTagList?.sites && sitesTagList.sites?.length) {
    let combinedResponse = { campus: {}, noCampus: [] };
    for (let i = 0; i < sitesTagList.sites?.length; i++) {
      const site = sitesTagList.sites[i];
      const campus = sitesTagList.campuses?.find(
        (c) => c.id === site.tagids?.[0]
      );
      if (campus) {
        combinedResponse.campus[campus.id] = {
          ...campus,
          nestedtags: combinedResponse.campus?.[campus.id]?.nestedtags || [],
        };
      }
      try {
        const response = yield call(
          getTagHierarchy,
          { maxdepth: 6 },
          { id: site.id }
        );
        if (campus) {
          const siteTagHierarchy = { ...site, nestedtags: [...response] };
          combinedResponse.campus[campus.id].nestedtags.push(siteTagHierarchy);
        } else {
          const siteTagHierarchy = { ...site, nestedtags: [...response] };
          combinedResponse.noCampus.push(siteTagHierarchy);
        }
      } catch (error) {
        yield put(setLoading(false));
        yield put(apiError(true));
        return;
      }
    }
    yield put(setCombinedSitesTagData(combinedResponse));
    const processedData = processSitesTags(combinedResponse);
    yield put(fetchSitesSuccess(processedData));
    yield put(setLoading(false));
    return;
  } else {
    yield put(setLoading(false));
    return;
  }
}

function processTags(tags) {
  const processedTableData = [];

  const processNestedTags = (
    nestedtags,
    cityName,
    stateName,
    stateTagId,
    cityTagId
  ) => {
    if (!nestedtags) return;
    nestedtags.forEach((tag) => {
      if (!tag) return;
      if (tag.kind === "ts.tag.city") {
        const cityTagId = tag.id;
        processNestedTags(
          tag.nestedtags,
          tag.name,
          stateName,
          stateTagId,
          cityTagId
        );
      } else if (tag.kind === "ts.tag.site") {
        const siteData = {
          key: tag.id,
          siteid: tag.id,
          sitename: tag.name,
          city: cityName,
          cityTagId,
          stateTagId,
          states: stateName,
          buildings: 1,
          isCampus: false,
        };
        processedTableData.push(siteData);
      } else if (tag.kind === "ts.tag.campus") {
        const campusName = tag.name;
        const campusTagId = tag.id;
        const sites =
          tag.nestedtags?.filter(
            (innerTag) => innerTag.kind === "ts.tag.site"
          ) || [];
        const numSites = sites?.length;
        const campusData = {
          key: tag.id,
          sitename: campusName,
          city: cityName,
          states: stateName,
          buildings: numSites,
          isCampus: true,
          children:
            sites?.length > 0
              ? sites?.map((site) => ({
                  key: site.id,
                  siteid: site.id,
                  campusTagId,
                  stateTagId,
                  cityTagId,
                  sitename: site.name,
                  city: cityName,
                  states: stateName,
                  buildings: 1,
                  parentCampus: campusName,
                  isCampus: false,
                }))
              : undefined,
        };
        processedTableData.push(campusData);
      }
    });
  };

  tags.forEach((tag) => {
    if (tag.kind === "ts.tag.state") {
      const stateName = tag.name;
      const stateTagId = tag.id;
      processNestedTags(tag.nestedtags, null, stateName, stateTagId);
    }
  });
  return processedTableData;
}

export function processSitesTags(tags) {
  const processedTableData = [];

  const processNestedTags = (
    nestedtags,
    countryTagName,
    countryTagId,
    stateTagName,
    stateTagId,
    cityTagName,
    cityTagId
  ) => {
    if (!nestedtags) return [];
    nestedtags.forEach((tag) => {
      if (!tag) return [];
      if (tag.kind === "ts.tag.country") {
        processNestedTags(tag.nestedtags, tag.name, tag.id);
      } else if (tag.kind === "ts.tag.state") {
        processNestedTags(
          tag.nestedtags,
          countryTagName,
          countryTagId,
          tag.name,
          tag.id
        );
      } else if (tag.kind === "ts.tag.city") {
        processNestedTags(
          tag.nestedtags,
          countryTagName,
          countryTagId,
          stateTagName,
          stateTagId,
          tag.name,
          tag.id
        );
      } else if (tag.kind === "ts.tag.campus") {
        const sites = tag.nestedtags;
        const tableData = {
          createdon: tag?.createdon,
          key: tag.id,
          campusId: tag.id,
          sitename: tag.name,
          city: cityTagName,
          states: stateTagName,
          stateId: stateTagId,
          buildings: sites?.length,
          isCampus: true,
          description: tag.description,
          children:
            sites?.length > 0
              ? sites?.map((site) => ({
                  key: site.id,
                  siteid: site.id,
                  campusTagName: tag.name,
                  campusTagId: tag.id,
                  siteTagName: site.name,
                  siteTagId: site.id,
                  description: site.description,
                  createdon: site.createdon,
                  stateTagName,
                  stateTagId,
                  cityTagName,
                  cityTagId,
                  countryTagName,
                  countryTagId,
                  sitename: site.name,
                  city: cityTagName,
                  states: stateTagName,
                  buildings: 1,
                  parentCampus: tag.name,
                  isCampus: false,
                  isSiteFromCampus: true,
                }))
              : undefined,
        };
        processedTableData.push(tableData);
      } else if (tag.kind === "ts.tag.site") {
        const tableData = {
          createdon: tag?.createdon,
          key: tag.id,
          siteid: tag.id,
          siteTagId: tag.id,
          sitename: tag.name,
          siteTagName: tag.name,
          city: cityTagName,
          stateTagName,
          stateTagId,
          description: tag.description,
          cityTagName,
          cityTagId,
          countryTagId,
          countryTagName,
          states: stateTagName,
          buildings: 1,
          isCampus: false,
        };
        processedTableData.push(tableData);
      }
    });
  };

  tags?.forEach((tag) => {
    processNestedTags([tag], false);
  });
  return processedTableData;
}

function* updateCampusDetailsSaga(action) {
  try {
    const {
      cid,
      finalPayload,
      activeSession,
      currentSiteTagList,
      resolve,
      reject,
    } = action.payload;

    const response = yield call(async () => {
      return await axiosInstance.patch(editTagEndPoint(), {
        accountname: activeSession.accountId,
        resourceidentifier: { id: cid },
        tag: { ...finalPayload },
      });
    });

    const result = response.data;

    if (result) {
      const updatedSiteTagList = {
        ...currentSiteTagList,
        campuses: currentSiteTagList.campuses.map((campus) =>
          campus?.id === cid && campus?.kind === "ts.tag.campus"
            ? {
                ...campus,
                id: result.id,
                name: result.name,
                description: result.description,
                tagids: [result.tagids[0]],
                kind: result.kind,
              }
            : campus
        ),
      };

      yield put(updateCampusDetails(updatedSiteTagList));
      if (resolve) resolve(result);
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.error_description ||
      "Failed to update Campus, please try again.";
    handleApiError("warning", errorMessage);
  }
}

function* watchUpdateCampusDetails() {
  yield takeEvery(types.UPDATE_CAMPUS_DETAILS_REQUEST, updateCampusDetailsSaga);
}

function* watchFetchAllTags() {
  yield takeEvery(types.FETCH_ALL_TAGS, fetchAllTags);
}

function* watchDeleteSite() {
  yield takeEvery(types.DELETE_SITE_REQUEST, deleteSite);
}

function* watchFetchCountryIds() {
  yield takeLeading(
    (action) => action.type === types.FETCH_COUNTRY_IDS_REQUEST && !action.force,
    fetchCountryIds
  );
}

function* watchFetchCountryIdsForced() {
  yield takeEvery(
    (action) => action.type === types.FETCH_COUNTRY_IDS_REQUEST && action.force,
    fetchCountryIds
  );
}

// function* watchFetchSites() {
//   yield takeEvery(types.FETCH_SITES_REQUEST, fetchSites);
// }

function* watchFetchAllSites() {
  yield takeEvery(types.FETCH_ALL_SITES, fetchAllSites);
}

export default function* sitesSaga() {
  yield all([
    watchDeleteSite(),
    watchFetchCountryIds(),
    watchFetchCountryIdsForced(),
    // watchFetchSites(),
    watchFetchAllTags(),
    watchFetchAllSites(),
    watchUpdateCampusDetails(),
  ]);
}
